import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import userContextReducer from './userContextReducer'
import layoutReducer from './layoutReducer'
import navbarReducer from './navbarReducer'
import chatbotReducer from './chatbotReducer'
import reportsReducer from './reportsReducer'
import databoxReducer from './databoxReducer'
import chatReducer from './chatReducer'
import rfpReducer from './rfpReducer'

const databoxPersistConfig = {
  key: 'databoxReducer',
  storage,
  blacklist: ['currentThread']
}

const rootReducer = combineReducers({
  layoutReducer,
  navbarReducer,
  userContextReducer,
  chatbotReducer,
  chatReducer,
  reportsReducer,
  databoxReducer: persistReducer(databoxPersistConfig, databoxReducer),
  rfpReducer
})

export default rootReducer
